import React from 'react';
import { Document } from '@react-pdf/renderer';
import { OrderInvoicePage } from './OrderInvoice';
import PrintSummaryPage from './PrintSummaryPage';
import PrintDividerPage from './PrintDividerPage';
import { splitOrdersByStock } from '../../utils/orderStock';

/**
 * Several orders' invoices as one print job.
 *
 * One Document holding many Pages, not many Documents: react-pdf renders a
 * single Document per job, so this is what lets the floor send a whole
 * selection to the printer in one pass instead of opening each order and
 * downloading its PDF.
 *
 * Ready stock orders are automatically grouped together and printed first.
 * If the batch contains both ready stock orders and production orders, a bold
 * physical `PrintDividerPage` separator sheet is placed in between them so the
 * physical paper stack can be instantly split without manual sorting.
 *
 * The first page is a summary sheet listing every order in the batch, broken
 * down into Ready Stock vs Production sections.
 */
const BulkOrderInvoice = ({ orders = [], company }) => {
  const { readyStockOrders, productionOrders } = splitOrdersByStock(orders);
  const isMixed = readyStockOrders.length > 0 && productionOrders.length > 0;
  const sortedOrders = isMixed ? [...readyStockOrders, ...productionOrders] : orders;

  return (
    <Document>
      <PrintSummaryPage orders={sortedOrders} />

      {readyStockOrders.map((order) => (
        <OrderInvoicePage key={order.id} order={order} company={company} />
      ))}

      {isMixed && <PrintDividerPage orderCount={productionOrders.length} />}

      {productionOrders.map((order) => (
        <OrderInvoicePage key={order.id} order={order} company={company} />
      ))}
    </Document>
  );
};

export default BulkOrderInvoice;
